import { render, staticRenderFns } from "./IconTextBox.vue?vue&type=template&id=31bcb1e4"
import script from "./IconTextBox.vue?vue&type=script&lang=js"
export * from "./IconTextBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports